import CryptoJS from 'crypto-js'
const asdgsdsdht =
  'dashsadfwathbgdfghrtjhtbrbsfbdbgdrthrdbdrghndrgnsrbsrbsgnbsgb'
export const encode = data => {
  var cdata = CryptoJS.AES.encrypt(data, asdgsdsdht)
  return cdata
}
export const decode = data => {
  if (!data) return
  var cdata = CryptoJS.AES.decrypt(data.toString(), asdgsdsdht)
  return cdata.toString(CryptoJS.enc.Utf8)
}
